import React from 'react'
import { Pie } from 'react-chartjs-2'
import { ChartData, ChartOptions, Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'

interface PieChartProps {
    chartData: ChartData<'pie'>
    chartOptions?: ChartOptions<'pie'>
    size?: number
}

const PieChart: React.FC<PieChartProps> = (props) => {
  ChartJS.register(ArcElement, Tooltip, Legend)
  return (
    <Pie
      data={props.chartData}
      options={props.chartOptions}
      height={props.size}
      width={props.size}
    />
  )
}
export default PieChart
